import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useMemo } from "react";
import { CDN_LINK } from "@globalConfig";
var WhyOurCompanySection = function WhyOurCompanySection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var whyOurCompanyItems = useMemo(function () {
    return [{
      key: "about_us/why_our_company_item1",
      text: tShort("about_us/why_our_company_item1", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/return.svg",
      alt: tLong("about_us/why_our_company_alt_item1", {
        ns: "web_common"
      }),
      width: 139,
      height: 98
    }, {
      key: "about_us/why_our_company_item2",
      text: tShort("about_us/why_our_company_item2", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/inspection.svg",
      alt: tLong("about_us/why_our_company_alt_item2", {
        ns: "web_common"
      }),
      width: 151,
      height: 98
    }, {
      key: "about_us/why_our_company_item3",
      text: tShort("about_us/why_our_company_item3", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/delivery.svg",
      width: 187,
      alt: tLong("about_us/why_our_company_alt_item3", {
        ns: "web_common"
      }),
      height: 91
    }, {
      key: "about_us/why_our_company_item4",
      text: tShort("about_us/why_our_company_item4", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/browse.svg",
      width: 227,
      alt: tLong("about_us/why_our_company_alt_item4", {
        ns: "web_common"
      }),
      height: 125
    }, {
      key: "about_us/why_our_company_item5",
      text: tShort("about_us/why_our_company_item5", {
        ns: "web_common"
      }),
      img: "/assets/images/about-us/key.svg",
      width: 140,
      alt: tLong("about_us/why_our_company_alt_item5", {
        ns: "web_common"
      }),
      height: 114
    }];
  }, [tShort, tLong]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "py-6 px-4 md:max-w-[1152px] md:mx-auto md:pb-[52px] md:px-0 md:py-[52px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8 md:gap-[72px]"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center text-primary text-3xl font-bold break-all"
  }, tShort("about_us/why_our_company_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8 md:flex-row md:flex-wrap md:gap-x-[21px] md:gap-y-12 md:justify-center"
  }, whyOurCompanyItems.map(function (item) {
    return /*#__PURE__*/React.createElement(WhyOurCompanyItem, _extends({
      key: item.key
    }, item));
  })))));
};
var WhyOurCompanyItem = function WhyOurCompanyItem(_ref) {
  var text = _ref.text,
    img = _ref.img,
    height = _ref.height,
    width = _ref.width,
    key = _ref.key,
    alt = _ref.alt;
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: "flex flex-col gap-4 md:w-[370px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-[#F4F9FE] h-[175px] flex items-center justify-center rounded"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + img,
    height: height,
    width: width,
    alt: alt,
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "px-5 text-center text-primary font-bold text-base md:text-xl"
  }, text)));
};
export default WhyOurCompanySection;